import axiosInstance from "../api";
import {
  GET_ACTIVE_PROJECT,
  GET_APPLIED_PROJECT,
  GET_COMPLETE_PROJECT,
  GET_MYOREDR_PROJECT,
  GET_PROJECT,
  GET_PROJECT_BY_ID,
  GET_PROJECT_PROPOSAL_BY_ID,
  GET_UMBERALLY_PROJECT,
} from "../constants";
import { urtoast } from "../../Components/Layouts/CustomPopup/eventEmitter";

export const getProjectList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?type=${type}&is_mine=1`);
    if (response?.data?.status) {
      dispatch({ type: GET_PROJECT, getprojectlist: response?.data?.response });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getMyOrderProjectList = (type, pagenumber, size, status) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?type=${type}&is_mine=1&index=${pagenumber}&size=${size}&status=${status}`,);
    if (response?.data?.status) {
      dispatch({
        type: GET_MYOREDR_PROJECT,
        myorderprojectlist: response?.data,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getUmbrallyProjectList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `post?type=1&is_mine=1&is_ambrella=1`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_UMBERALLY_PROJECT,
        getumbrallyprojectlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getAppliedProjectList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(
      `post?type=${type}&proposed=1`,
    );
    if (response?.data?.status) {
      dispatch({
        type: GET_APPLIED_PROJECT,
        getprojectappliedlist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getPostPaginationList = (data) => async (dispatch) => {
  try {
    const params = new URLSearchParams();
    const besttype = data?.url ? data?.url : 'post';

    if (data?.type) params.append("type", data.type);
    if (data?.index) params.append("index", data.index);
    if (data?.size) params.append("size", data.size);
    if (data?.status) params.append("status", data.status);
    if (data?.proposed) params.append("proposed", data.proposed);
    if (data?.declined) params.append("declined", data.declined);
    if (data?.is_mine) params.append("is_mine", data.is_mine);
    if (data?.is_bxp) params.append("is_bxp", data.is_bxp);

    const finalUrl = `${besttype}?${params.toString()}`;
    console.log("Final request URL =>", finalUrl);

    const response = await axiosInstance.get(finalUrl);
    return response?.data;
  } catch (err) {
    //urtoast(err.message, 2);
  }
};



export const getProjectActiveList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?type=${type}&status=2`);
    if (response?.data?.status) {
      dispatch({
        type: GET_ACTIVE_PROJECT,
        getprojectactivelist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getProjectCompleteList = (type) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post?type=${type}&status=3`);
    if (response?.data?.status) {
      dispatch({
        type: GET_COMPLETE_PROJECT,
        getprojectcompletelist: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const sendProjectProposal =
  (data, setLoading, navigate) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("proposal/create", data);
      if (response?.data?.status) {
        setLoading(false);
        urtoast(response?.data?.response?.message, 1);
        navigate(data?.url, {
          state: { post_id: data?.post_id, type: "project" },
        });
        // window.location.reload()
        return;
      }
      urtoast(response?.data?.response?.message, 2);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      //urtoast(err.message, 2);
    }
  };

export const updateProjectProposal = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("proposal/update", data);
    if (response?.data?.status) {
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      window.location.reload();
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const addProject = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.post("post/create", data);
    if (response?.data?.status) {
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      window.location.reload();
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const getProjectById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`post/id?id=${id}`);
    if (response?.data?.status) {
      dispatch({
        type: GET_PROJECT_BY_ID,
        getprojectbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const getProjectProposalById = (id) => async (dispatch) => {
  try {
    const response = await axiosInstance.get(`proposal/id?id=${id}&type=4`);
    if (response?.data?.status) {
      dispatch({
        type: GET_PROJECT_PROPOSAL_BY_ID,
        getprojectproposalbyid: response?.data?.response,
      });
      return;
    }
    urtoast(response?.data?.response?.message, 2);
  } catch (err) {
    //urtoast(err.message, 2);
  }
};

export const submitprojectMilestoneWork =
  (data, setLoading) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("milestone/update", data);
      if (response?.data?.status) {
        setLoading(false);
        urtoast(response?.data?.response?.message, 1);
        // window.location.reload();
        return;
      }
      urtoast(response?.data?.response?.message, 2);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      //urtoast(err.message, 2);
    }
  };

export const approvprojectMilestoneWork =
  (data, setLoading) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("milestone/create", data);
      if (response?.data?.status) {
        setLoading(false);
        urtoast(response?.data?.response?.message, 1);

        setTimeout(() => {
          window.location.reload();
        }, 1000); // 2 seconds delay

        return;
      }
      urtoast(response?.data?.response?.message, 2);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      //urtoast(err.message, 2);
    }
  };

export const approvMilestoneProjectMilestone =
  (data, setLoading) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("milestone/update", data);
      if (response?.data?.status) {
        setLoading(false);
        urtoast(response?.data?.response?.message, 1);
        window.location.reload();
        return;
      }
      urtoast(response?.data?.response?.message, 2);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      //urtoast(err.message, 2);
    }
  };

export const approwmilestonestatus = (data, setLoading) => async (dispatch) => {
  setLoading(true);
  try {
    const response = await axiosInstance.put("milestone/update", data);
    if (response?.data?.status) {
      setLoading(false);
      urtoast(response?.data?.response?.message, 1);
      window.location.reload();
      return;
    }
    urtoast(response?.data?.response?.message, 2);
    setLoading(false);
  } catch (err) {
    setLoading(false);
    //urtoast(err.message, 2);
  }
};

export const approvsubmitedMilestoneWork =
  (data, setLoading) => async (dispatch) => {
    setLoading(true);
    try {
      const response = await axiosInstance.put("milestone/update", data);
      if (response?.data?.status) {
        setLoading(false);
        urtoast(response?.data?.response?.message, 1);
        window.location.reload();
        return;
      }
      urtoast(response?.data?.response?.message, 2);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      //urtoast(err.message, 2);
    }
  };
